import { SxProps, Theme } from '@mui/material/styles';
import { createContext, useContext } from 'react';

import { Spacing, VariantBodyType } from '../theme/type';

export type ListItemState = {
  margin?: Spacing;
  padding?: Spacing;
  sx?: SxProps<Theme>;
  variant?: VariantBodyType;
};

export const ListContext = createContext<ListItemState | undefined>(undefined);

export const useListContext = (): ListItemState | undefined =>
  useContext<ListItemState | undefined>(ListContext);
